<script setup lang="ts">
  import { HeaderTableWithButtons, SearchNoResults } from '@/shared/ui';
  import HistoryTableRow from './HistoryTableRow.vue';
  import { TableHeader } from '@/shared/ui';
  import type { ValidityHistoryItem, FilterOptions } from '@/entities/Document';
  import { OrderOptions } from '@/shared/lib';

  defineProps<{
    revisions: ValidityHistoryItem[];
    page: number;
    orderOptions?: OrderOptions[];
    isFilterActive?: boolean;
    currentFilters?: FilterOptions;
  }>();

  const emit = defineEmits(['update:sort', 'update:filter', 'filter-clicked', 'delete']);

  const handleSortOptions = (sortCamp: string, orderFlow: string) => {
    emit('update:sort', sortCamp, orderFlow);
  };

  const handleFilter = (filters: FilterOptions) => {
    emit('update:filter', filters);
  };

  const handleFilterClicked = () => {
    emit('filter-clicked');
  };

  const handleDelete = (id: number) => {
    emit('delete', id);
  };
</script>

<template>
  <div class="bg-white-01 rounded-lg shadow-sm border border-gray-02 overflow-x-auto">
    <table class="w-full">
      <thead>
        <tr>
          <HeaderTableWithButtons
            id="header-table-with-buttons"
            colspan="7"
            text="Relatórios"
            :has-filter="true"
            :is-filter-active="isFilterActive"
            :order-options="orderOptions"
            :current-filters="currentFilters"
            @update:sort="handleSortOptions"
            @update:filter="handleFilter"
            @filter-clicked="handleFilterClicked"
          />
        </tr>
        <tr
          v-if="revisions.length"
          class="border-b border-gray-02 table-row-hover"
        >
          <TableHeader
            text="Prefixo"
            class="text-xs/5"
          />
          <TableHeader
            text="Título"
            class="text-xs/5"
          />
          <TableHeader
            text="Rev."
            class="text-xs/5"
          />
          <TableHeader
            text="Elaborado por"
            class="text-xs/5"
          />
          <TableHeader
            text="Aprovado por"
            class="text-xs/5"
          />
          <TableHeader
            text="Verificado por"
            class="text-xs/5"
          />
          <TableHeader
            text="Vigência"
            class="text-xs/5"
          />
        </tr>
      </thead>
      <tbody class="bg-white-01 divide-y divide-gray-02">
        <tr v-if="!revisions.length">
          <td
            colspan="7"
            class="py-8"
          >
            <SearchNoResults />
          </td>
        </tr>
        <HistoryTableRow
          v-for="revision in revisions"
          :key="revision.id"
          :revision="revision"
          @delete="handleDelete"
        />
      </tbody>
    </table>
  </div>
</template>
